<div class="teacher-layout">
  <!-- Left column: workgroup/student sidebar — hidden on mobile via CSS -->
  @if (!bulkRating) {
  <div class="registration-area desktop-only">
    <button mat-stroked-button color="primary" class="btn-above-content" (click)="bulkRating = true; setBulkData()"
      [disabled]="loadingCaseTaskWorkgroups">
      {{ 'case.tasks.bulk-rating' | translate | capitalize }}
    </button>
    <h2 class="sidebar-heading">{{ 'general.words.workgroups' | translate | capitalize }}</h2>
    @if (loadingCaseTaskWorkgroups) {
    <mat-spinner></mat-spinner>
    }
    @if (!loadingCaseTaskWorkgroups && workgroupRegistrationMenuItems.length === 0) {
    <span class="sidebar-empty-notice">
      <i>{{ 'case.tasks.no-workgroups-connected' | translate | capitalize }}</i>
    </span>
    }
    <app-select-list [data]="workgroupRegistrationMenuItems" [selectedId]="selectedRegistrationId"
      (selectedIdChange)="setSelectedRegistration($event)"></app-select-list>
    <mat-list>
      <h2 class="workgroup-list-item-title">
        {{ 'case.tasks.individual-students' | translate | capitalize }}
      </h2>
      @if (loadingCaseTaskWorkgroups) {
      <mat-spinner></mat-spinner>
      }
      @if (!loadingCaseTaskWorkgroups && studentRegistrationMenuItems.length > 0) {
      <app-select-list [selectedId]="selectedRegistrationId" (selectedIdChange)="setSelectedRegistration($event)"
        [data]="studentRegistrationMenuItems"></app-select-list>
      }
      @if (!loadingCaseTaskWorkgroups && studentRegistrationMenuItems.length === 0) {
      <span class="sidebar-empty-notice">
        <i>{{ 'case.no-linked-students' | translate | capitalize }}</i>
      </span>
      }
    </mat-list>
  </div>
  }

  <!-- Center + right panel -->
  @if (!bulkRating) {

  <!-- MOBILE: three-tab group (list / submission / rating) — hidden on desktop via CSS -->
  <mat-tab-group class="mobile-tab-group mobile-only"
    [selectedIndex]="mobileTabIndex[mobileTab]"
    (selectedIndexChange)="onMobileTabChange($event)">

    <!-- Tab 0: student / workgroup list -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">people</mat-icon>
        {{ 'general.words.students' | translate | capitalize }}
      </ng-template>
      <div class="registration-area registration-area--mobile">
        <button mat-stroked-button color="primary" class="btn-above-content"
          (click)="bulkRating = true; setBulkData()"
          [disabled]="loadingCaseTaskWorkgroups">
          {{ 'case.tasks.bulk-rating' | translate | capitalize }}
        </button>
        <h2 class="sidebar-heading">{{ 'general.words.workgroups' | translate | capitalize }}</h2>
        @if (loadingCaseTaskWorkgroups) {
        <mat-spinner></mat-spinner>
        }
        @if (!loadingCaseTaskWorkgroups && workgroupRegistrationMenuItems.length === 0) {
        <span class="sidebar-empty-notice">
          <i>{{ 'case.tasks.no-workgroups-connected' | translate | capitalize }}</i>
        </span>
        }
        <app-select-list [data]="workgroupRegistrationMenuItems" [selectedId]="selectedRegistrationId"
          (selectedIdChange)="setSelectedRegistration($event)"></app-select-list>
        <mat-list>
          <h2 class="workgroup-list-item-title">
            {{ 'case.tasks.individual-students' | translate | capitalize }}
          </h2>
          @if (loadingCaseTaskWorkgroups) {
          <mat-spinner></mat-spinner>
          }
          @if (!loadingCaseTaskWorkgroups && studentRegistrationMenuItems.length > 0) {
          <app-select-list [selectedId]="selectedRegistrationId" (selectedIdChange)="setSelectedRegistration($event)"
            [data]="studentRegistrationMenuItems"></app-select-list>
          }
          @if (!loadingCaseTaskWorkgroups && studentRegistrationMenuItems.length === 0) {
          <span class="sidebar-empty-notice">
            <i>{{ 'case.no-linked-students' | translate | capitalize }}</i>
          </span>
          }
        </mat-list>
      </div>
    </mat-tab>

    <!-- Tab 1: submission / form content -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">description</mat-icon>
        {{ 'general.words.submitted-at' | translate | capitalize }}
      </ng-template>
      <div class="registration-content registration-content--mobile">
        @if (!selectedRegistration) {
        <div class="content-notice">
          <mat-icon class="notice-icon">people</mat-icon>
          <span><i>{{ 'case.tasks.choose-workgroup-or-student' | translate | capitalize }}</i></span>
        </div>
        }
        @if (selectedRegistration &&
          ((selectedRegistration.registrations &&
            selectedRegistration.registrations.length === 1 &&
            selectedRegistration.registrations[0].functionRegistrations &&
            selectedRegistration.registrations[0].functionRegistrations.length === 0) ||
           (selectedWorkgroupRegistration &&
            (!selectedWorkgroupRegistration.functionRegistrations ||
              selectedWorkgroupRegistration.functionRegistrations.length === 0))) &&
          !dataRegistration) {
        <div class="content-notice">
          <span>
            {{ 'general.notifications.no-registrations' | translate | capitalize }}
            {{ 'general.words.submitted' | translate }}
          </span>
        </div>
        }
        @if (previewNotAvailable) {
        <div class="content-notice">
          <span>{{ 'general.notifications.preview-not-available' | translate | capitalize }}</span>
        </div>
        }
        @if (dataRegistration && !data.task.isQuiz) {
        <div class="registration-wrapper">
          @if (functionType === 'form' || functionType === 'formGroupForm' || functionType === 'anamnesisForm') {
          <app-task-registration-data [close-button]="false" [data]="dataRegistration" [functionType]="'form'">
          </app-task-registration-data>
          }
          @if (functionType === 'careplan') {
          <app-task-registration-data [close-button]="false" [data]="dataRegistration"
            [careInstitutionId]="data.careInstitutionId" [functionType]="'careplan'">
          </app-task-registration-data>
          }
          @if (functionType === 'careplan-nnn') {
          <app-task-registration-data [close-button]="false" [data]="dataRegistration"
            [careInstitutionId]="data.careInstitutionId" [patientId]="data.patientId" [functionType]="'careplan-nnn'">
          </app-task-registration-data>
          }
        </div>
        }
        @if (quizResult && data.task.isQuiz) {
        <div class="registration-wrapper">
          <app-quiz-result [data]="quizResult"></app-quiz-result>
        </div>
        }
        @if (loading) {
        <mat-spinner class="content-spinner"></mat-spinner>
        }
      </div>
    </mat-tab>

    <!-- Tab 2: rating & state -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">grade</mat-icon>
        {{ 'general.words.rating' | translate | capitalize }}
      </ng-template>
      <div class="teacher-right-panel teacher-right-panel--mobile">
        <h2 class="teacher-title">{{ data.task.title }}</h2>

        @if (data.task.functionToSubmit !== null && data.task.functionToSubmit.id !== null) {
        <p class="hint-text">
          <i>{{
            'case.tasks.function-registration-needs-submitted'
            | translate: { FUNCTION_NAME: data.task.functionToSubmit.title }
            | capitalize
            }}</i>
        </p>
        }

        @if (selectedRegistration && selectedRegistration.registrations) {
        <!-- Submission card -->
        <div class="content-card">
          <p class="section-header">{{ 'general.words.submitted-at' | translate | capitalize }}</p>

          @if (selectedRegistration.registrations.length === 0) {
            @if (data.task.toSubmit) {
            <p class="meta-empty">{{ 'case.tasks.nothing-submitted' | translate | capitalize }}</p>
            }
            @if (!data.task.toSubmit) {
            <p class="meta-empty">{{ 'case.tasks.nothing-needs-submitted' | translate | capitalize }}</p>
            }
          }

          @if (selectedRegistration.registrations.length === 1) {
          <p class="meta-value" [class.p-no-margin]="!selectedRegistration.workgroup.isStudent">
            {{
            'general.notifications.submitted-at-date-by-user'
            | translate
            : {
              DATE: selectedRegistration.registrations[0].submittedTimestamp | date: 'dd MMMM yyyy',
              TIME: selectedRegistration.registrations[0].submittedTimestamp | date: 'HH:mm',
              FIRSTNAME: selectedRegistration.registrations[0].submittedBy.firstname,
              LASTNAME: selectedRegistration.registrations[0].submittedBy.lastname
              }
            | capitalize
            }}
          </p>
          }

          @if (selectedRegistration.registrations.length > 1) {
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>{{ 'general.words.submitted-at' | translate | capitalize }}</mat-label>
            <mat-select (selectionChange)="onRegistrationChange($event)"
              [formControl]="selectedWorkgroupRegistrationFormControl">
              @for (reg of selectedRegistration.registrations | sortBy: 'asc' : 'submittedTimestamp'; track reg) {
              <mat-option [value]="reg">
                <span class="bold">{{ reg.submittedTimestamp | date: 'dd MMMM yyyy' }}</span>&nbsp;
                {{ 'general.words.at' | translate }}&nbsp;
                <span class="bold">{{ reg.submittedTimestamp | date: 'HH:mm' }}</span>
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
          }

          @if (selectedWorkgroupRegistration && selectedWorkgroupRegistration.functionRegistrations.length > 1) {
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>{{ 'case.tasks.submitted-registrations' | translate | capitalize }}</mat-label>
            <mat-select (selectionChange)="onWorkgroupFunctionRegistrationChange($event)"
              [formControl]="selectedWorkgroupFunctionRegistrationFormControl">
              @for (reg of selectedWorkgroupRegistration.functionRegistrations; track reg) {
              <mat-option [value]="reg">
                {{ reg.function.title }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
          }

          @if (selectedWorkgroupRegistration) {
            @if (!selectedRegistration.workgroup.isStudent && selectedRegistration.registrations.length > 1) {
            <p class="meta-value">
              {{ 'general.words.by' | translate }}
              <span class="bold">
                {{ selectedWorkgroupRegistration.submittedBy.firstname }}
                {{ selectedWorkgroupRegistration.submittedBy.lastname }}
              </span>
            </p>
            }
            <p class="section-header">{{ 'general.words.comments' | translate | capitalize }}</p>
            @if (selectedWorkgroupRegistration.comments) {
            <p class="meta-value">{{ selectedWorkgroupRegistration.comments }}</p>
            } @else {
            <p class="meta-empty">-</p>
            }
          }
        </div>

        <!-- Rating card -->
        <div class="content-card">
          <p class="section-header">{{ 'general.words.rating' | translate | capitalize }}</p>

          @if (!data.task.toRate) {
          <p class="meta-empty">{{ 'case.tasks.no-rating-needed' | translate | capitalize }}</p>
          }

          @if (data.task.toRate) {
            @if (ratingLoading) {
            <mat-spinner diameter="36"></mat-spinner>
            }
            @if (selectedWorkgroupRegistration &&
              selectedWorkgroupRegistration.caseRatingRegistration &&
              !editRating && !ratingLoading) {
            <div class="rating-badge" matRipple (click)="editRating = true">
              <span>{{ selectedWorkgroupRegistration.caseRatingRegistration.caseRating.name }}</span>
              <mat-icon color="primary">edit</mat-icon>
            </div>
            <p class="meta-muted">
              {{
              'case.tasks.rated-at-date-by-user'
              | translate
              : {
                DATE: selectedWorkgroupRegistration.caseRatingRegistration.registeredOn | date: 'dd MMMM yyyy',
                TIME: selectedWorkgroupRegistration.caseRatingRegistration.registeredOn | date: 'HH:mm',
                FIRSTNAME: selectedWorkgroupRegistration.caseRatingRegistration.registeredBy.firstname,
                LASTNAME: selectedWorkgroupRegistration.caseRatingRegistration.registeredBy.lastname
                }
              | capitalize
              }}
            </p>
            <p class="section-header">{{ 'general.words.comments' | translate | capitalize }}:</p>
            @if (selectedWorkgroupRegistration.caseRatingRegistration.comments) {
            <p class="meta-value">{{ selectedWorkgroupRegistration.caseRatingRegistration.comments }}</p>
            } @else {
            <p class="meta-empty">-</p>
            }
            }
            @if ((!selectedWorkgroupRegistration || !selectedWorkgroupRegistration.caseRatingRegistration || editRating) && !ratingLoading) {
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>{{ data.caseRatingSystem.name }}</mat-label>
              <mat-select [formControl]="selectedRatingFormControl">
                @for (rating of data.caseRatingSystem.caseRatings | sortBy: 'asc' : 'order'; track rating) {
                <mat-option [value]="rating">
                  {{ rating.name }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>{{ 'general.words.comments' | translate | capitalize }}</mat-label>
              <textarea matInput [formControl]="newRatingCommentsFormControl"></textarea>
            </mat-form-field>
            <div class="footer-row">
              <button mat-raised-button (click)="submitRating()" color="primary">
                {{ 'general.actions.rate' | translate | capitalize }}
              </button>
            </div>
            }
          }
        </div>

        <!-- State card -->
        <div class="content-card">
          <p class="section-header">{{ 'general.words.state' | translate | capitalize }}</p>
          <mat-form-field appearance="outline" class="full-width">
            <mat-select [formControl]="selectedTaskStateFormControl" (selectionChange)="saveState()">
              @for (state of taskStates | sortBy: 'asc' : 'order'; track state) {
              <mat-option class="state-select-option" [value]="state.name">
                <app-state-box [state]="state.name" [student]="false" position="left"></app-state-box>
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        }
      </div>
    </mat-tab>

  </mat-tab-group>

  <!-- DESKTOP: original two separate columns — hidden on mobile via CSS -->
  <div class="registration-content desktop-only">
    @if (!selectedRegistration) {
    <div class="content-notice">
      <mat-icon class="notice-icon">arrow_back</mat-icon>
      <span><i>{{ 'case.tasks.choose-workgroup-or-student' | translate | capitalize }}</i></span>
    </div>
    }
    @if (selectedRegistration &&
      ((selectedRegistration.registrations &&
        selectedRegistration.registrations.length === 1 &&
        selectedRegistration.registrations[0].functionRegistrations &&
        selectedRegistration.registrations[0].functionRegistrations.length === 0) ||
       (selectedWorkgroupRegistration &&
        (!selectedWorkgroupRegistration.functionRegistrations ||
          selectedWorkgroupRegistration.functionRegistrations.length === 0))) &&
      !dataRegistration) {
    <div class="content-notice">
      <span>
        {{ 'general.notifications.no-registrations' | translate | capitalize }}
        {{ 'general.words.submitted' | translate }}
      </span>
    </div>
    }
    @if (previewNotAvailable) {
    <div class="content-notice">
      <span>{{ 'general.notifications.preview-not-available' | translate | capitalize }}</span>
    </div>
    }
    @if (dataRegistration && !data.task.isQuiz) {
    <div class="registration-wrapper">
      @if (functionType === 'form' || functionType === 'formGroupForm' || functionType === 'anamnesisForm') {
      <app-task-registration-data [close-button]="false" [data]="dataRegistration" [functionType]="'form'">
      </app-task-registration-data>
      }
      @if (functionType === 'careplan') {
      <app-task-registration-data [close-button]="false" [data]="dataRegistration"
        [careInstitutionId]="data.careInstitutionId" [functionType]="'careplan'">
        </app-task-registration-data>
      }
      @if (functionType === 'careplan-nnn') {
      <app-task-registration-data [close-button]="false" [data]="dataRegistration"
        [careInstitutionId]="data.careInstitutionId" [patientId]="data.patientId" [functionType]="'careplan-nnn'">
      </app-task-registration-data>
      }
    </div>
    }
    @if (quizResult && data.task.isQuiz) {
    <div class="registration-wrapper">
      <app-quiz-result [data]="quizResult"></app-quiz-result>
    </div>
    }
    @if (loading) {
    <mat-spinner class="content-spinner"></mat-spinner>
    }
  </div>

  <!-- Right column: task details, rating, state — hidden on mobile via CSS -->
  <div class="teacher-right-panel desktop-only">
    <!-- Task title -->
    <h2 class="teacher-title">{{ data.task.title }}</h2>

    @if (data.task.functionToSubmit !== null && data.task.functionToSubmit.id !== null) {
    <p class="hint-text">
      <i>{{
        'case.tasks.function-registration-needs-submitted'
        | translate: { FUNCTION_NAME: data.task.functionToSubmit.title }
        | capitalize
        }}</i>
    </p>
    }

    @if (selectedRegistration && selectedRegistration.registrations) {
    <!-- Submission card -->
    <div class="content-card">
      <p class="section-header">{{ 'general.words.submitted-at' | translate | capitalize }}</p>

      @if (selectedRegistration.registrations.length === 0) {
        @if (data.task.toSubmit) {
        <p class="meta-empty">{{ 'case.tasks.nothing-submitted' | translate | capitalize }}</p>
        }
        @if (!data.task.toSubmit) {
        <p class="meta-empty">{{ 'case.tasks.nothing-needs-submitted' | translate | capitalize }}</p>
        }
      }

      @if (selectedRegistration.registrations.length === 1) {
      <p class="meta-value" [class.p-no-margin]="!selectedRegistration.workgroup.isStudent">
        {{
        'general.notifications.submitted-at-date-by-user'
        | translate
        : {
          DATE: selectedRegistration.registrations[0].submittedTimestamp | date: 'dd MMMM yyyy',
          TIME: selectedRegistration.registrations[0].submittedTimestamp | date: 'HH:mm',
          FIRSTNAME: selectedRegistration.registrations[0].submittedBy.firstname,
          LASTNAME: selectedRegistration.registrations[0].submittedBy.lastname
          }
        | capitalize
        }}
      </p>
      }

      @if (selectedRegistration.registrations.length > 1) {
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'general.words.submitted-at' | translate | capitalize }}</mat-label>
        <mat-select (selectionChange)="onRegistrationChange($event)"
          [formControl]="selectedWorkgroupRegistrationFormControl">
          @for (reg of selectedRegistration.registrations | sortBy: 'asc' : 'submittedTimestamp'; track reg) {
          <mat-option [value]="reg">
            <span class="bold">{{ reg.submittedTimestamp | date: 'dd MMMM yyyy' }}</span>&nbsp;
            {{ 'general.words.at' | translate }}&nbsp;
            <span class="bold">{{ reg.submittedTimestamp | date: 'HH:mm' }}</span>
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
      }

      @if (selectedWorkgroupRegistration && selectedWorkgroupRegistration.functionRegistrations.length > 1) {
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'case.tasks.submitted-registrations' | translate | capitalize }}</mat-label>
        <mat-select (selectionChange)="onWorkgroupFunctionRegistrationChange($event)"
          [formControl]="selectedWorkgroupFunctionRegistrationFormControl">
          @for (reg of selectedWorkgroupRegistration.functionRegistrations; track reg) {
          <mat-option [value]="reg">
            {{ reg.function.title }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
      }

      @if (selectedWorkgroupRegistration) {
        @if (!selectedRegistration.workgroup.isStudent && selectedRegistration.registrations.length > 1) {
        <p class="meta-value">
          {{ 'general.words.by' | translate }}
          <span class="bold">
            {{ selectedWorkgroupRegistration.submittedBy.firstname }}
            {{ selectedWorkgroupRegistration.submittedBy.lastname }}
          </span>
        </p>
        }
        <p class="section-header">{{ 'general.words.comments' | translate | capitalize }}</p>
        @if (selectedWorkgroupRegistration.comments) {
        <p class="meta-value">{{ selectedWorkgroupRegistration.comments }}</p>
        } @else {
        <p class="meta-empty">-</p>
        }
      }
    </div>

    <!-- Rating card -->
    <div class="content-card">
      <p class="section-header">{{ 'general.words.rating' | translate | capitalize }}</p>

      @if (!data.task.toRate) {
      <p class="meta-empty">{{ 'case.tasks.no-rating-needed' | translate | capitalize }}</p>
      }

      @if (data.task.toRate) {
        @if (ratingLoading) {
        <mat-spinner diameter="36"></mat-spinner>
        }
        @if (selectedWorkgroupRegistration &&
          selectedWorkgroupRegistration.caseRatingRegistration &&
          !editRating && !ratingLoading) {
        <div class="rating-badge" matRipple (click)="editRating = true">
          <span>{{ selectedWorkgroupRegistration.caseRatingRegistration.caseRating.name }}</span>
          <mat-icon color="primary">edit</mat-icon>
        </div>
        <p class="meta-muted">
          {{
          'case.tasks.rated-at-date-by-user'
          | translate
          : {
            DATE: selectedWorkgroupRegistration.caseRatingRegistration.registeredOn | date: 'dd MMMM yyyy',
            TIME: selectedWorkgroupRegistration.caseRatingRegistration.registeredOn | date: 'HH:mm',
            FIRSTNAME: selectedWorkgroupRegistration.caseRatingRegistration.registeredBy.firstname,
            LASTNAME: selectedWorkgroupRegistration.caseRatingRegistration.registeredBy.lastname
            }
          | capitalize
          }}
        </p>
        <p class="section-header">{{ 'general.words.comments' | translate | capitalize }}:</p>
        @if (selectedWorkgroupRegistration.caseRatingRegistration.comments) {
        <p class="meta-value">{{ selectedWorkgroupRegistration.caseRatingRegistration.comments }}</p>
        } @else {
        <p class="meta-empty">-</p>
        }
        }
        @if ((!selectedWorkgroupRegistration || !selectedWorkgroupRegistration.caseRatingRegistration || editRating) && !ratingLoading) {
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ data.caseRatingSystem.name }}</mat-label>
          <mat-select [formControl]="selectedRatingFormControl">
            @for (rating of data.caseRatingSystem.caseRatings | sortBy: 'asc' : 'order'; track rating) {
            <mat-option [value]="rating">
              {{ rating.name }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ 'general.words.comments' | translate | capitalize }}</mat-label>
          <textarea matInput [formControl]="newRatingCommentsFormControl"></textarea>
        </mat-form-field>
        <div class="footer-row">
          <button mat-raised-button (click)="submitRating()" color="primary">
            {{ 'general.actions.rate' | translate | capitalize }}
          </button>
        </div>
        }
      }
    </div>

    <!-- State card -->
    <div class="content-card">
      <p class="section-header">{{ 'general.words.state' | translate | capitalize }}</p>
      <mat-form-field appearance="outline" class="full-width">
        <mat-select [formControl]="selectedTaskStateFormControl" (selectionChange)="saveState()">
          @for (state of taskStates | sortBy: 'asc' : 'order'; track state) {
          <mat-option class="state-select-option" [value]="state.name">
            <app-state-box [state]="state.name" [student]="false" position="left"></app-state-box>
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    }
  </div>

  }

<!-- Bulk rating view -->
@if (bulkRating) {
<div class="bulk-layout">
  <app-task-bulk-rating [workgroups]="bulkWorkgroups" [task]="data.task" [caseId]="data.caseId"
    [caseRatingSystem]="data.caseRatingSystem" [taskStates]="taskStates" (closeRequested)="bulkRating = false">
  </app-task-bulk-rating>
</div>
}
</div>
